import { useMemo } from 'react'
import { USER_ROLES, USER_TYPES, USER_TYPES_IN_EVENT } from '@utils/constants'
import { COOKIE_KEYS, getCookie, LOCALSTORAGE_KEYS } from '@features/General'

function useUserRole() {
    const eventId = getCookie(COOKIE_KEYS.ALA_EVENT)
    const userProfile: any = JSON.parse(localStorage.getItem(LOCALSTORAGE_KEYS.USERINFO))
    const contactProfile: any = JSON.parse(localStorage.getItem(LOCALSTORAGE_KEYS.CONTACT_INFO))
    const selectedEvent = eventId ? userProfile?.eventInfos.find(item => item.eventId === eventId) : null
    const userType = selectedEvent?.role?.type
    const userRole = selectedEvent?.role?.title
    const companyUserType: typeof USER_TYPES_IN_EVENT[keyof typeof USER_TYPES_IN_EVENT] | undefined =
        contactProfile?.userType || undefined

    const isUserType = userType === USER_TYPES.USER
    const isAdminType = userType === USER_TYPES.ADMIN
    const isOrganizerType = userType === USER_TYPES.ORGANIZER

    const isOperation = userRole === USER_ROLES.OPERATION
    const isAdmin = userRole === USER_ROLES.ADMIN
    const isTeamManager = userRole === USER_ROLES.TEAM_MANAGER
    const isUser = userRole === USER_ROLES.USER
    const isViewer = userType === USER_ROLES.VIEWER

    const isHost = useMemo(
        () =>
            (selectedEvent?.role?.type === USER_TYPES.USER && companyUserType === USER_TYPES_IN_EVENT.HOST) ||
            (selectedEvent?.role?.type === USER_TYPES.USER && companyUserType === USER_TYPES_IN_EVENT.EXHIBITOR),
        [eventId, selectedEvent, companyUserType]
    )

    return {
        userRole,
        isHost,
        userType,
        userProfile,
        eventId,
        selectedEvent,
        companyUserType,
        contactProfile,
        userTypes: {
            isUserType,
            isAdminType,
            isOrganizerType
        },
        roles: {
            isOperation,
            isAdmin,
            isTeamManager,
            isViewer,
            isUser
        }
    }
}

export default useUserRole
